
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useSupabase } from "@/hooks/useSupabase";

export const useSubscription = () => {
  const { user, isLoggedIn } = useSupabase();

  const { data: subscriptionData, isLoading: isCheckingAccess } = useQuery({
    queryKey: ['subscription-status', user?.id],
    queryFn: async () => {
      if (!user) return { 
        hasPremiumAccess: false, 
        tier: 'basic', 
        nextBilling: null,
        paymentMethod: null 
      };
      console.log('Checking subscription status for user:', user.id);
      
      try {
        // Call the check-subscription edge function to verify subscription status
        const { data, error } = await supabase.functions.invoke('check-subscription');
        
        if (error) {
          console.error('Subscription check error:', error);
          throw error;
        }
        
        console.log('Subscription check result:', data);
        
        // Return formatted subscription data
        return {
          hasPremiumAccess: data?.subscribed || false,
          tier: data?.subscription_tier || 'basic',
          nextBilling: data?.subscription_end || null,
          paymentMethod: data?.payment_method || null
        };
      } catch (err) {
        console.error('Error in subscription check:', err);
        return { 
          hasPremiumAccess: false, 
          tier: 'basic', 
          nextBilling: null,
          paymentMethod: null 
        };
      }
    },
    enabled: !!user,
    staleTime: 5 * 60 * 1000, // Cache for 5 minutes
  });

  console.log('useSubscription hook result:', { 
    userId: user?.id, 
    isLoggedIn, 
    subscriptionData 
  });

  return {
    hasPremiumAccess: isLoggedIn ? (subscriptionData?.hasPremiumAccess || false) : false,
    subscriptionTier: subscriptionData?.tier || 'basic',
    nextBilling: subscriptionData?.nextBilling || null,
    paymentMethod: subscriptionData?.paymentMethod || null,
    isCheckingAccess
  };
};
